import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';

import { TEXT_KEYS } from './content-banner.constants';
import './content-banner.styles.less';

class ContentBanner extends React.Component<IContentBannerProps> {
    public render(): JSX.Element {
        return (
            <div className="sitegen-content-banner">
                {this.createTitle()}
                {this.createDescription()}
            </div>
        );
    }

    public createTitle(): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey, originalTranslateKey } = this.props;
        const gameName: string = originalTranslateKey(TEXT_KEYS.GAME_NAME);
        const localizedTitle: JSX.Element = translateKey(TEXT_KEYS.EVENT_TITLE, { gameName });

        return (
            <h1 className="sitegen-content-banner__title">
                <span>{localizedTitle}</span>
                {this.props.extraTitle}
            </h1>
        );
    }

    public createDescription(): JSX.Element | null {
        if (!this.props.description) {
            return null;
        }

        return <h2 className="sitegen-content-banner__description">{this.props.description}</h2>;
    }
}

export interface IContentBannerProps extends ITranslationProps {
    readonly extraTitle?: JSX.Element | null;
    readonly description?: JSX.Element | null;
}

export default translate()(ContentBanner);
